import React from 'react';
import { Phone, Crown, Gift, Eye, Edit, BookOpen, Calendar, ShieldOff, Trash2, UserPlus } from 'lucide-react';
import MaterialsList from './MaterialsList';

const UserCard = ({ 
  user, 
  onView, 
  onEdit, 
  onGift, 
  onAccess, 
  onSubscribe, 
  onRevoke, 
  onDelete,
  getUserTrainingsList,
  getUserCoursesList,
  trainingsMap,
  coursesMap,
  expandedMaterials,
  toggleMaterialsExpand,
  getTrainingAccess,
  getCourseAccess
}) => {
  return (
    <div className="bg-gray-700/30 rounded-lg p-3 border border-gray-700">
      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-900/50 to-purple-900/50 flex items-center justify-center flex-shrink-0 border border-gray-600">
          {user.premium ? <Crown className="w-5 h-5 text-yellow-400" /> : <UserPlus className="w-5 h-5 text-gray-400" />}
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-sm font-medium text-white truncate">{user.fullName || 'Без имени'}</div>
          <div className="text-xs text-gray-400 truncate">@{user.username || 'без username'}</div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2 text-xs mb-3">
        <div className="flex items-center gap-1">
          <Phone className="w-3 h-3 text-gray-400" />
          <span className="text-gray-300 truncate">{user.phone || '—'}</span>
        </div>
        <div className="flex items-center gap-1">
          <Crown className="w-3 h-3 text-yellow-400" />
          <span className={`px-1.5 py-0.5 rounded text-xs ${user.premium ? 'bg-yellow-900/30 text-yellow-300' : 'bg-gray-700 text-gray-300'}`}>
            {user.premium ? 'Premium' : 'Free'}
          </span>
        </div>
        <div className="col-span-2">
          <MaterialsList 
            user={user}
            getUserTrainingsList={getUserTrainingsList}
            getUserCoursesList={getUserCoursesList}
            trainingsMap={trainingsMap}
            coursesMap={coursesMap}
            expandedMaterials={expandedMaterials}
            toggleMaterialsExpand={toggleMaterialsExpand}
            getTrainingAccess={getTrainingAccess}
            getCourseAccess={getCourseAccess}
          />
        </div>
        <div className="flex items-center gap-1">
          <Gift className="w-3 h-3 text-green-400" />
          <span className="text-green-400">{user.refBonus?.toLocaleString() || 0} €</span>
        </div>
      </div>

      <div className="flex flex-wrap gap-1 pt-2 border-t border-gray-700">
        <button onClick={() => onView(user)} className="flex items-center justify-center gap-1 px-2 py-1.5 bg-blue-900/30 text-blue-300 rounded text-xs font-medium border border-blue-700">
          <Eye className="w-3 h-3" /> Просмотр
        </button>
        <button onClick={() => onEdit(user)} className="flex items-center justify-center gap-1 px-2 py-1.5 bg-green-900/30 text-green-300 rounded text-xs font-medium border border-green-700">
          <Edit className="w-3 h-3" /> Редакт
        </button>
        <button onClick={() => onGift(user)} className="flex items-center justify-center gap-1 px-2 py-1.5 bg-pink-900/30 text-pink-300 rounded text-xs font-medium border border-pink-700">
          <Gift className="w-3 h-3" /> Подарки
        </button>
        <button onClick={() => onAccess(user)} className="flex items-center justify-center gap-1 px-2 py-1.5 bg-purple-900/30 text-purple-300 rounded text-xs font-medium border border-purple-700">
          <BookOpen className="w-3 h-3" /> Доступ
        </button>
        {user.premium ? (
          <>
            <button onClick={() => onSubscribe(user, 'extend')} className="flex items-center justify-center gap-1 px-2 py-1.5 bg-blue-900/30 text-blue-300 rounded text-xs font-medium border border-blue-700">
              <Calendar className="w-3 h-3" /> Продлить
            </button>
            <button onClick={() => onRevoke(user)} className="flex items-center justify-center gap-1 px-2 py-1.5 bg-red-900/30 text-red-300 rounded text-xs font-medium border border-red-700">
              <ShieldOff className="w-3 h-3" /> Отозвать
            </button>
          </>
        ) : (
          <button onClick={() => onSubscribe(user, 'grant')} className="flex items-center justify-center gap-1 px-2 py-1.5 bg-yellow-900/30 text-yellow-300 rounded text-xs font-medium border border-yellow-700">
            <Crown className="w-3 h-3" /> Выдать
          </button>
        )}
        <button onClick={() => onDelete(user.id)} className="flex items-center justify-center gap-1 px-2 py-1.5 bg-red-900/30 text-red-300 rounded text-xs font-medium border border-red-700">
          <Trash2 className="w-3 h-3" /> Удалить
        </button>
      </div>
    </div>
  );
};

export default UserCard;